// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { getLocator } from '@tcp/core/src/utils';
import { TOP_RATED } from '@tcp/core/src/constants/badge.constants';
import BadgeContainer from '../styles/CustomBadge.style';

const asPathConstructor = (url) => {
  return url && url.replace('?cid=', '/');
};

const CustomBadge = (props) => {
  const {
    customFontWeight,
    customFontSize,
    text,
    link,
    type,
    className,
    linkClassName,
    sortByRatingLabel,
  } = props;
  const encodeLabel = encodeURI(sortByRatingLabel);
  const { pathSuffix, displayName } = link;
  return (
    <BadgeContainer className={`${className} top-badge-container`} type={type}>
      <BodyCopy
        dataLocator={getLocator('global_productbadge_txt')}
        fontFamily="secondary"
        component="div"
        fontWeight={customFontWeight || 'bold'}
        fontSize={customFontSize}
        className="top-badge"
        tabIndex="0"
        aria-label={
          type === TOP_RATED && displayName ? `${text} in ${displayName}` : `${text} Badge`
        }
      >
        <span className="top-badge-label">{text}</span>
        {type === TOP_RATED && displayName && (
          <>
            <span>&nbsp;in&nbsp;</span>
            <Anchor
              className={`${linkClassName} underline`}
              to={`/${pathSuffix}&viaBreadCrumb=true&sort=${encodeLabel}`}
              asPath={`/${asPathConstructor(pathSuffix)}?sort=${encodeLabel}`}
              title={displayName}
            >
              {displayName}
            </Anchor>
          </>
        )}
      </BodyCopy>
    </BadgeContainer>
  );
};

CustomBadge.defaultProps = {
  type: '',
  className: '',
  text: '',
  linkClassName: '',
  link: {
    displayName: '',
    pathSuffix: '',
  },
  customFontWeight: '',
  customFontSize: ['fs10', 'fs10', 'fs10'],
};

CustomBadge.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  linkClassName: PropTypes.string,
  link: PropTypes.shape({
    displayName: PropTypes.string,
    pathSuffix: PropTypes.string,
  }),
  customFontWeight: PropTypes.string,
  customFontSize: PropTypes.arrayOf(PropTypes.string),
};

export default CustomBadge;
